module.exports = __webpack_public_path__ + "img/Barakat-h.bce79643.png";